document.addEventListener('DOMContentLoaded', function () {

  const schedulerOptions = {
    schedulerId: 'sched_fy2agssj57x4ldyxlrtc9i75'
  };

  function openScheduler(e) {
    e.preventDefault();

    if (typeof _scheduler !== 'undefined') {
      _scheduler.show(schedulerOptions);
    } else {
      console.warn('Scheduler not loaded yet');
    }
  }

  const selectors = [
    'a[href="#schedule-service"]',
    'button[href="#schedule-service"]',
    '[data-schedule-service]'
  ];

  selectors.forEach(function(selector) {
    document.querySelectorAll(selector).forEach(function(el) {
      el.addEventListener('click', openScheduler);
    });
  });

});